






























































































































































































































































import { computed, defineComponent, watch } from '@vue/composition-api';
import dayjs from 'dayjs';
import { HelpIcon, InfoCircleFilledIcon } from 'tdesign-icons-vue';

// 引入compositions
import historyHandler from '@/renderer/components/SpacePage/compositions/historyHandler';
import linkShareHandler, { LinkNameFilter } from '@/renderer/components/dialog/linkShare/composition/linkShareHandler';
import shareInWeMeetingHandler from '@/renderer/views/desktop/headbar/composition/shareInWeMeetingHandler';
import linkDownAndPreviewHandler from '@/renderer/components/linkList/compositions/linkDownAndPreviewHandler';

// 引入工具类
import { PAY_SOURCE, openTeamPayDialog } from '@/renderer/scripts/composition/dialogHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';

const disableDate = {
  before: dayjs(),
  after: dayjs().add(50, 'year').format('YYYY-MM-DD HH:mm:ss'),
};
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    linkData: {
      required: false,
      type: Object,
    },
    viewData: {
      required: false,
      type: Object,
    },
  },
  components: {
    HelpIcon,
    InfoCircleFilledIcon,
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { $store } = context.root;
    const { nicknameMaxLength } = ConstantConfig;
    const renderData = computed(() => props.linkData || props.viewData);
    const linkShareFilename = computed<string>(
      () => props.linkData?.name || (props.viewData && LinkNameFilter(props.viewData)),
    );
    const { methods: linkDownAndPreview } = linkDownAndPreviewHandler();
    const { historyConfig, methods: historyMethods } = historyHandler();
    const { methods: wemeetingMethods } = shareInWeMeetingHandler();
    const {
      linkSetShow,
      extractionCodeCheck,
      extractionCodeFormat,
      enabelWatermarkText,
      watermarkTextFormat,
      formData,
      expireDay,
      expireDayShow,
      linkUrl,
      linkCode,
      copyValue,
      isCreate,
      isChange,
      showModify,
      allowEmptyWatermarkText,
      methods: linkShareMethods,
    } = linkShareHandler();
    const isMultiFile = computed(() => props.linkData?.type === 'multi-file' || props.viewData?.type === 'multi-file');
    const showCountLimit = computed(() => {
      const file = props.viewData || props.linkData?.directoryInfoList?.[0];
      const isFile = file?.type !== 'dir';
      return !isMultiFile.value && isFile;
    });
    const isPersonal = computed(() => $store.getters.editionFlag === 'personal');
    const methods = {
      getFormDataOrViewData() {
        // 当链接修改的时候，预览次数与下载次数的上限，需要通过 formData 来获取
        return linkSetShow.value ? renderData.value : formData;
      },
      cancel() {
        innerShow.value = false;
        linkShareMethods.reset();
      },
      init() {
        innerShow.value && historyMethods.getHistoryConfig(); // 创建或更新时查询
        linkShareMethods.init();
      },
      shareInWemeet() {
        wemeetingMethods.shareUrlInWemeet({
          name: props.viewData?.name,
          url: linkUrl.value,
          code: linkCode.value,
        });
      },
      showPay() {
        if (!isPersonal.value) return;
        openTeamPayDialog(PAY_SOURCE.OPEN_SHARE_LINK_LIMIT);
      },
    };
    watch(innerShow, () => {
      if (innerShow.value) {
        methods.init();
      }
    });
    return {
      innerShow,
      isMultiFile,
      linkShareFilename,
      renderData,
      linkDownAndPreview,
      showCountLimit,
      linkSetShow,
      extractionCodeCheck,
      extractionCodeFormat,
      enabelWatermarkText,
      watermarkTextFormat,
      formData,
      expireDay,
      expireDayShow,
      linkUrl,
      linkCode,
      copyValue,
      isCreate,
      isChange,
      nicknameMaxLength,
      ...methods,
      ...linkShareMethods,
      historyConfig,
      disableDate,
      isPersonal,
      showModify,
      allowEmptyWatermarkText,
      wemeetingMethods,
    };
  },
});
